import baseApi from "./baseApi";
import axios from "axios";


const uploadAvatar = (r) => axios.post(`upload/Avatar/`, r, { headers: { 'Authorization': 'Bearer ' + baseApi.getToken() } });
const uploadLogo = (r) => axios.post(`upload/Logo/`, r, { headers: { 'Authorization': 'Bearer ' + baseApi.getToken() } });



export default {
    uploadAvatar,
    uploadLogo
};